<template>
	<div class="inventory-psi-container">
		<!-- 盘点向导主页面 -->
		<div class="inventory-wizard" v-show="!showTaskForm && !showInventoryDetail">
			<div class="wizard-header">
				<h1>盘点向导</h1>
				<p>设置盘点任务规则</p>
				<div class="header-right">
					<span class="date">{{ currentDate }}</span>
					<span class="version">V1.1</span>
					<el-button type="text" @click="showProcessGuide">盘点流程说明</el-button>
				</div>
			</div>

			<div class="wizard-content">
				<!-- 创建任务模块 -->
				<div class="task-module">
					<div class="module-icon">
						<i class="el-icon-circle-plus-outline"></i>
					</div>
					<h3>创建盘点任务</h3>
					<p>在任务中设置盘点规则，给规则进行盘点</p>
					<el-button type="primary" class="create-btn" @click="showCreateTaskForm">
						创建任务
					</el-button>
				</div>

				<!-- 已有任务模块 -->
				<div class="task-module">
					<div class="module-icon">
						<i class="el-icon-search"></i>
					</div>
					<h3>已有任务，去盘点</h3>
					<p>多台盘点时，各盘点参与或选择已存在的任务进行盘点</p>
					<el-button type="primary" class="inventory-btn" @click="showExistingTasks">
						进行盘点
					</el-button>
				</div>
			</div>
		</div>

		<!-- 创建任务表单 - 使用zoom过渡动画 -->
		<transition name="el-zoom-in-center">
			<div class="task-form-container" v-show="showTaskForm">
				<div class="task-form">
					<div class="form-header">
						<h2>盘点向导</h2>
						<p>设置盘点任务规则</p>
					</div>

					<el-form :model="taskForm" :rules="taskRules" ref="taskForm" label-width="120px">
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="任务名称：" prop="taskName">
									<el-input v-model="taskForm.taskName" placeholder="请输入任务名称"
										:value="defaultTaskName">
									</el-input>
								</el-form-item>
							</el-col>

							<el-col :span="12">
								<el-form-item label="盘点仓库：" prop="warehouse">
									<el-select v-model="taskForm.warehouse" placeholder="请选择盘点仓库">
										<el-option label="西药库" value="1"></el-option>
										<el-option label="中药库" value="2"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="库存日期：" prop="inventoryDateType">
									<el-radio-group v-model="taskForm.inventoryDateType">
										<el-radio label="immediate">即时库存</el-radio>
										<el-radio label="specified">指定日期</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>

							<el-col :span="12" v-if="taskForm.inventoryDateType === 'specified'">
								<el-form-item label="预定日期：" prop="specifiedDate">
									<el-date-picker v-model="taskForm.specifiedDate" type="datetime"
										placeholder="选择日期时间">
									</el-date-picker>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="盘点模式：" prop="inventoryMode">
									<el-radio-group v-model="taskForm.inventoryMode">
										<el-radio label="single">
											单人盘点(根据盘点任务,生成单人盘点单,直接在系统中录入盘点数据,审核处理)
										</el-radio>
										<el-radio label="multiple" disabled>
											多人盘点(先创建盘点任务,生成多人盘点单,再将单人分配到各盘点单与单人录入盘点数据,然后集中汇总盘点单,审核处理)
										</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
						</el-row>

						<!-- <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="商品范围：" prop="productRange">
                  <el-radio-group v-model="taskForm.productRange">
                    <el-radio label="all">全盘</el-radio>
                    <el-radio label="drawer">抽屉</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              
              <el-col :span="12">
                <el-form-item label="商品来源：" prop="productSource">
                  <el-checkbox-group v-model="taskForm.productSource">
                    <el-checkbox label="inventory">在盘点仓库中有交易记录的商品</el-checkbox>
                    <el-checkbox label="loss">包含损耗商品</el-checkbox>
                    <el-checkbox label="nonInventory">包含非库存商品</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="盘点规则：" prop="inventoryRules">
                  <el-checkbox-group v-model="taskForm.inventoryRules">
                    <el-checkbox label="batch">按批次保质期盘点</el-checkbox>
                    <el-checkbox label="serial">按序列号盘点</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              
              <el-col :span="12">
                <el-form-item label="商品清单显示：" prop="productListDisplay">
                  <el-radio-group v-model="taskForm.productListDisplay">
                    <el-radio label="blank">空白盘点单</el-radio>
                    <el-radio label="show">显示商品清单</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row> -->

						<el-form-item label="单据备注：" prop="remark">
							<el-input type="textarea" v-model="taskForm.remark" placeholder="请输入备注信息" :rows="3">
							</el-input>
						</el-form-item>
					</el-form>

					<div class="form-actions">
						<el-button type="primary" @click="createTask" :loading="creating">
							创建任务
						</el-button>
						<el-button @click="cancelCreate">取消</el-button>
					</div>
				</div>
			</div>
		</transition>

		<!-- 创建成功模态框 -->
		<el-dialog title="创建成功" :visible.sync="showSuccessDialog" width="400px" center>
			<div class="success-content">
				<i class="el-icon-success success-icon"></i>
				<p class="success-message">
					单人盘点【{{ createdTaskName }}】任务创建成功
				</p>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="goToInventory">去盘点</el-button>
				<el-button @click="backToList">返回盘点列表页</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'InventoryPsi',
		data() {
			return {
				// 主页面状态
				showTaskForm: false,
				showInventoryDetail: false,

				// 成功对话框状态
				showSuccessDialog: false,
				creating: false,
				createdTaskName: '',

				// 当前日期
				currentDate: this.formatDate(new Date()),

				// 任务表单数据
				taskForm: {
					taskName: '',
					warehouse: '',
					lockWarehouse: true,
					inventoryDateType: 'immediate',
					specifiedDate: '',
					inventoryMode: 'single',
					inventoryPersonnel: [],
					productRange: 'all',
					productSource: ['inventory'],
					inventoryRules: ['batch'],
					productListDisplay: 'show',
					remark: ''
				},

				// 表单验证规则
				taskRules: {
					taskName: [{
						required: true,
						message: '请输入任务名称',
						trigger: 'blur'
					}],
					warehouse: [{
						required: true,
						message: '请选择盘点仓库',
						trigger: 'change'
					}],
					inventoryMode: [{
						required: true,
						message: '请选择盘点模式',
						trigger: 'change'
					}]
				}
			}
		},

		computed: {
			// 默认任务名称
			defaultTaskName() {
				const now = new Date();
				return `${this.formatDateTime(now)} 创建的盘点单`;
			}
		},

		methods: {
			// 格式化日期
			formatDate(date) {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				return `${year}年${month}月${day}日`;
			},

			// 格式化日期时间
			formatDateTime(date) {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				const seconds = String(date.getSeconds()).padStart(2, '0');
				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},

			// 显示流程说明
			showProcessGuide() {
				this.$message.info('盘点流程说明功能开发中');
			},

			// 显示创建任务表单
			showCreateTaskForm() {
				this.taskForm.taskName = this.defaultTaskName;
				this.showTaskForm = true;
			},

			// 显示已有任务
			showExistingTasks() {
				this.$message.info('已有任务功能开发中');
			},

			// 创建任务
			createTask() {
				this.$refs.taskForm.validate((valid) => {
					if (valid) {
						this.creating = true;

						// 模拟创建任务过程
						setTimeout(() => {
							this.creating = false;
							this.createdTaskName = this.taskForm.taskName;
							this.showSuccessDialog = true;
							this.showTaskForm = false;
						}, 1000);
					}
				});
			},

			// 取消创建
			cancelCreate() {
				this.showTaskForm = false;
				this.$refs.taskForm.resetFields();
			},

			// 去盘点
			goToInventory() {
				this.showSuccessDialog = false;
				this.$router.push('/PSI/addInventoryPsi');
			},

			// 返回列表
			backToList() {
				this.showSuccessDialog = false;
				this.$refs.taskForm.resetFields();
			}
		}
	}
</script>

<style lang="less" scoped>
	.inventory-psi-container {
		min-height: 100vh;
		background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
		padding: 20px;
	}

	.inventory-wizard {
		max-width: 1200px;
		margin: 0 auto;
		background: white;
		border-radius: 10px;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
		overflow: hidden;
	}

	.wizard-header {
		background: #409EFF;
		color: white;
		padding: 30px 40px;
		position: relative;

		h1 {
			margin: 0 0 10px 0;
			font-size: 32px;
			font-weight: bold;
		}

		p {
			margin: 0;
			font-size: 16px;
			opacity: 0.9;
		}

		.header-right {
			position: absolute;
			right: 40px;
			top: 30px;
			text-align: right;

			.date {
				display: block;
				font-size: 18px;
				margin-bottom: 5px;
			}

			.version {
				display: block;
				font-size: 14px;
				opacity: 0.8;
				margin-bottom: 10px;
			}
		}
	}

	.wizard-content {
		display: flex;
		justify-content: space-around;
		padding: 60px 40px;
		gap: 40px;
	}

	.task-module {
		flex: 1;
		max-width: 400px;
		text-align: center;
		padding: 40px 30px;
		background: #f8f9fa;
		border-radius: 10px;
		transition: all 0.3s ease;

		&:hover {
			transform: translateY(-5px);
			box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
		}

		.module-icon {
			font-size: 60px;
			color: #409EFF;
			margin-bottom: 20px;
		}

		h3 {
			margin: 0 0 15px 0;
			font-size: 24px;
			color: #333;
		}

		p {
			color: #666;
			line-height: 1.6;
			margin-bottom: 25px;
		}

		.create-btn,
		.inventory-btn {
			width: 200px;
			height: 45px;
			font-size: 16px;
		}
	}

	.task-form-container {
		max-width: 1000px;
		margin: 0 auto;
		background: white;
		border-radius: 10px;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
		overflow: hidden;
	}

	.task-form {
		padding: 30px;

		.form-header {
			text-align: center;
			margin-bottom: 30px;

			h2 {
				margin: 0 0 10px 0;
				color: #333;
				font-size: 28px;
			}

			p {
				margin: 0;
				color: #666;
				font-size: 16px;
			}
		}
	}

	.lock-switch {
		margin-left: 10px;
	}

	.switch-label {
		margin-left: 5px;
		color: #666;
		font-size: 14px;
	}

	.form-actions {
		text-align: center;
		margin-top: 30px;
		padding-top: 20px;
		border-top: 1px solid #eee;

		.el-button {
			width: 120px;
			height: 40px;
			margin: 0 10px;
		}
	}

	.success-content {
		text-align: center;
		padding: 20px 0;

		.success-icon {
			font-size: 60px;
			color: #67C23A;
			margin-bottom: 20px;
		}

		.success-message {
			font-size: 16px;
			color: #333;
			line-height: 1.5;
			margin: 0;
		}
	}

	// 响应式设计
	@media (max-width: 768px) {
		.inventory-psi-container {
			padding: 10px;
		}

		.wizard-content {
			flex-direction: column;
			padding: 30px 20px;
			gap: 20px;
		}

		.task-module {
			max-width: none;
		}

		.wizard-header {
			padding: 20px;

			.header-right {
				position: static;
				text-align: left;
				margin-top: 15px;
			}
		}

		.task-form {
			padding: 20px;
		}
	}

	// 过渡动画
	.el-zoom-in-center-enter-active,
	.el-zoom-in-center-leave-active {
		transition: all 0.3s ease;
	}

	.el-zoom-in-center-enter,
	.el-zoom-in-center-leave-to {
		opacity: 0;
		transform: scale(0.95);
	}
</style>